import { CHANNEL_META, type ChannelMeta } from './ChannelIcons';

/** Darker per-channel icon colors for SMALL chips only — the shared
 *  CHANNEL_META accents sit at 2.2–2.6:1 on their pastels, under the 3:1
 *  non-text minimum; -700-scale shades pass without touching the palette
 *  other sections use at larger sizes. Keep in step with ChannelIcons'
 *  chipBg pastels when those change. */
export const CHIP_ICON_COLOR: Partial<Record<ChannelMeta['key'], string>> = {
  phone: '#047857',
  sms: '#1D4ED8',
  whatsapp: '#15803D',
  email: '#C2410C',
  slack: '#6D28D9',
};

/** Small round channel chip (matches the TrendSection / TessaIdentity chips). */
export function ChannelChip({ channel }: { channel: ChannelMeta['key'] }) {
  const meta = CHANNEL_META.find((c) => c.key === channel);
  if (!meta) return null;
  const Icon = meta.Icon;
  return (
    <span
      className="inline-flex h-6 w-6 items-center justify-center rounded-md"
      style={{ background: meta.chipBg, color: CHIP_ICON_COLOR[channel] ?? meta.accent }}
      title={meta.label}
    >
      <Icon width={13} height={13} />
    </span>
  );
}
